module.exports = __webpack_public_path__ + "img/specialities.1db1dbfa.svg";